'use client';

import { useEffect } from 'react';

import { NotAuthorizedIcon } from '@cloudquery/base-icons';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { sendGTMEvent } from '../../utils/gtm';

interface Props {
  returnTo: string;
}

export function NotAuthorized({ returnTo }: Props) {
  useEffect(() => {
    sendGTMEvent({ error_code: '401', event: 'error_page', path: window.location.pathname });
  }, []);

  return (
    <Box alignItems="center" component="main" display="flex" flexGrow={1} paddingY={10}>
      <Container maxWidth="xl">
        <Box display="flex" justifyContent="center" marginBottom={3}>
          <NotAuthorizedIcon sx={{ height: 128, width: 'auto' }} />
        </Box>
        <Typography align="center" marginBottom={1} variant="h5">
          401: Not authorized
        </Typography>
        <Typography
          align="center"
          marginBottom={3}
          sx={{ color: 'text.secondary' }}
          variant="body1"
        >
          You are not authorized to access this page.
        </Typography>
        <Box display="flex" justifyContent="center" marginBottom={6}>
          <Button
            endIcon={<ChevronRightIcon />}
            href={returnTo ?? '/'}
            size="medium"
            variant="contained"
          >
            Take Me Home
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
